import ALLOWED_KEYS from '@/utils/constants/cell-allowed-keys';
import rangeFocusHandler from '@/utils/range-focus-handler';
import getSelection from '@/utils/get-selection';
import getCellId from '@/utils/get-table-cell-id';

const contenteditableCell = {
  data() {
    return {
      // Если у ячейки есть дропдаун, при блюре закрываем его руками через эту переменную
      showDropdown: false,
      // '.00'
      LENGTH_OF_FRACTIONAL_PART: 3,
    };
  },
  computed: {
    cellId() {
      return getCellId({
        isBreakdown: +!!this.isBreakdown,
        field: this.field,
        rowId: this.rowId || this.row.id,
      });
    },
  },
  methods: {
    // Событие клика именно на значение (не любую область ячейки) (превентится для установки каретки в зону клика)
    valueClickHandler() {
      // Открывать дропдаун даже в случае клика на значение
      if (this.contentEditable) {
        this.showDropdown = true;
      }
    },
    // event в начале, так как функция вызывается по клику из-под шаблонизатора в том числе
    focusValue($event, customCellId = '') {
      if (this.contentEditable) {
        // ВНИМАНИЕ, КОСТЫЛЬ, взятый по ссылке
        // https://stackoverflow.com/questions/2388164/set-focus-on-div-contenteditable-element
        // Нужен для фокуса именно на элементе значения ячейки, минуя валюту и другие элементы родительского элемента
        // Айдишник генерится как составной ключ из ключа столбца и айдишника строки
        const p = rangeFocusHandler(customCellId || this.cellId);
        if (this.setFocusedValue) {
          this.setFocusedValue(p.textContent.trim());
        }
      }
    },
    blurCellValue(e, cellInfo) {
      let cellValue =
        this.$refs.cellValue.innerText?.trim() || this.$refs.cellValueWrapper.innerText?.trim();
      if (this.focusedValue !== cellValue) {
        // Если в дочернем и родительском элементе отсутствует численное
        // значение (оставили пустую строку), то слать 0
        if (this.isNumber) {
          cellValue = cellValue.split(' ').join('');
        }
        this.$emit('edit-cell-value', {
          ...cellInfo,
          value: cellValue,
        });
      }
      if (this.setFocusedValue) {
        this.setFocusedValue(null);
      }
    },
    async keydownCellValue(e) {
      if (e.key === 'Enter') {
        // Поведение завершения ввода и блюр
        e.preventDefault();
        if (document) {
          document.activeElement.blur();
        }
      } else if (e.type === 'paste' || (e.key === 'v' && e.metaKey)) {
        if (this.isNumber) {
          const clipboardData = e.clipboardData;
          const pastedData = clipboardData?.getData('Text') || '';
          const pastedValueIsNaN = isNaN(Number(pastedData));
          const pastedValueLength = pastedData.length;
          const currentCellValue = this.$refs.cellValue.innerText?.trim().replace(/\s/g, '');
          const currentSelection = getSelection({ isClear: true });
          if (
            pastedValueLength + currentCellValue?.length - currentSelection.length >
              this.MAX_NUMBER_LENGTH ||
            pastedValueIsNaN
          ) {
            e.preventDefault();
          }
        }
      } else if (this.isNumber) {
        const cellValue = this.$refs.cellValue.innerText.trim().replace(/\s/g, '');
        const cellValueBeforePoint = cellValue.split('.')[0];
        // Обнуление инпута при стирании строки
        if (this.$refs.cellValue.innerText?.trim().length <= 1 && e.key === 'Backspace') {
          e.preventDefault();
          this.$refs.cellValue.innerText = '0';
          // Проверка нажатия валидной кнопки
        } else if (!ALLOWED_KEYS.includes(e.key)) {
          e.preventDefault();
        } else if (
          // Проверка длины числа до точки и длины всего числа
          (cellValueBeforePoint.length >= this.MAX_NUMBER_LENGTH ||
            cellValue.length >= this.MAX_NUMBER_LENGTH + this.LENGTH_OF_FRACTIONAL_PART) &&
          e.key !== 'Backspace' &&
          // Если вся строка не выделена (если веделена вся строка, то перезаписываем ее новым значением)
          getSelection({ isClear: true }) !== this.value.replace(/\s/g, '')
        ) {
          e.preventDefault();
        }
      }
    },
  },
};

export default contenteditableCell;
